
import Vue from 'vue';
import { createPopper, Instance } from '@popperjs/core';

interface PopperVueData {
  vuePopperInstance: Instance | undefined;
}

export default Vue.extend({
  name: 'PopperVue',
  model: {
    prop: 'show',
  },
  props: {
    arrow: {
      type: Boolean,
      default: false,
    },
    arrowClass: {
      type: [Object, Array, String],
      default: undefined,
    },
    /**
     * Any options should follow popper documentation
     * https://popper.js.org/docs/v2/
     */
    options: {
      type: Object,
      default: () => {},
    },
    popperClass: {
      type: [Object, Array, String],
      default: undefined,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data(): PopperVueData {
    return {
      vuePopperInstance: undefined,
    };
  },
  watch: {
    options: {
      handler(options) {
        this.vuePopperInstance?.setOptions(options);
      },
      deep: true,
    },
  },
  mounted() {
    this.vuePopperInstance = createPopper(
      this.$refs.reference as HTMLElement,
      this.$refs.popper as HTMLElement,
      this.options,
    );
    this.$emit('popper', this.vuePopperInstance);
  },
});
